// extracted by mini-css-extract-plugin
export default {"section":"CreditRestorationQuiz_section__M5sYu","holder":"CreditRestorationQuiz_holder__ve+eg","stepper":"CreditRestorationQuiz_stepper__mltXs"};